import "./App.css";
import { createContext, useEffect, useRef, useState } from "react";
import { Buffer } from "buffer";

import MastermindBoard from "./components/MastermindBoard";
import { FaAngleDoubleDown } from "react-icons/fa";
import Guide from "./components/Guide";
import { HappyFaceIcon, PingIcon, SadFaceIcon, SettingIcon, ShieldExclamationIcon } from "./components/Icons";
import Settings from "./components/Settings";
import { Theme } from "./components/Theme";
import {Notification, SuccessNotification} from "./components/Notification";
import Modal from "./components/Modal";
import Peg from "./components/Peg";


export const ThemeContext = createContext();

// pegs to choose from
const CODES = [
  "#FFB400",
  "#D61355",
  "#00FFCA",
  "#A555EC",
  "#609966",
  "#362FD9",
];

export default function App() {

  const _level = localStorage.getItem('level') ? JSON.parse(localStorage.getItem('level')) : {
    title: "Hard",
    pegsInRow:4,
    attempts: 10,
    bgColor: "bg-red-900"
  };

  // game pick up 
  const [gamePickUp, setGamePickUp] = useState(false);

  // game level
  const [level, setLevel] = useState(_level);
  const [ATTEMPTS, setAttempts] = useState(_level.attempts);
  const [PEGSINROW, setPegsInRow] = useState(_level.pegsInRow);

  // rules display state
  const [displayRules, setDisplayRules] = useState(false);
  const [openSettings, setSettings] = useState(false);

  //theme 
  const _theme = localStorage.getItem('theme')
  const [theme, setTheme] = useState(_theme ? JSON.parse(_theme) : Theme.White);

  //notification
  const [showNotification, setNotification] = useState(false);

  // success code
  const [SUCCESSCODE, setSuccessCode] = useState(new Map());

  // track which decode row is currently activated
  const [activatedRow, setActivatedRow] = useState(0);
  // for decode rows
  const [decodeRowsHints, setDecodeRowsHints] = useState(new Array(ATTEMPTS).fill([]));

  // rows answers stack
  const createDecodeRows = () => {
    let _rowsAnswers = {}
    for(let i =0; i < ATTEMPTS; i++){
      _rowsAnswers[i] = {};
      for(let j = 0; j < PEGSINROW; j++){
        _rowsAnswers[i][j] = "";
      }
    }
    return _rowsAnswers;
  }
  const [rowsAnswers, setRowsAnswers] = useState(() => createDecodeRows());

  // is row decoded or not
  const [decodeRows, setDecodeRows] = useState(new Array(ATTEMPTS).fill(false));

  // winner or loser trackers
  const [outOfChances, setOutOfChances] = useState(false);
  const [winnerModal, setWinnerModal] = useState(false);

  useEffect(() => {
    setAttempts(level.attempts);
    setPegsInRow(level.pegsInRow);
  }, [level])

  //create unique code set
  const createCode = () => {
    const _code = new Map();
    let min = 0;
    let max = CODES.length - 1;
    for (let i = 0; i < PEGSINROW; i++) {
      const pickRandomCode = CODES[Math.floor(Math.random() * (max - min + 1)) + min]
      _code.set(i, pickRandomCode);
    }
    setSuccessCode(_code);
  };

  useEffect(() => {
    createCode();
  }, [ATTEMPTS, PEGSINROW]);

  // pick game where user left
  useEffect(() => {
    setTimeout(() => {
      setNotification(true)
    }, 15000);
    const _hints = JSON.parse(localStorage.getItem('hints'));
    const _activatedRow = JSON.parse(localStorage.getItem('activatedRow'));
    const _decodeRows = JSON.parse(localStorage.getItem('decoded'));
    const _rowsAnswers = JSON.parse(localStorage.getItem('decodes'));
    const _successCode = JSON.parse(localStorage.getItem('codex'));
    const _SUCCESSCODE = new Map();
    if(_hints && _hints.length && _activatedRow && _decodeRows && _decodeRows.length && _rowsAnswers && Object.values(_rowsAnswers).length && _successCode && _successCode.length){
      _successCode.forEach(code => {
        _SUCCESSCODE.set(code[0], Buffer.from(code[1], 'base64').toString('ascii'));
      });
      setGamePickUp(true);
      setDecodeRowsHints(_hints);
      setActivatedRow(_activatedRow);
      setDecodeRows(_decodeRows);
      setRowsAnswers(_rowsAnswers);
      setSuccessCode(_SUCCESSCODE);
    }
  },[])

  // reset 
  const restartGame = () => {
    setActivatedRow(0);
    setDecodeRowsHints(new Array(ATTEMPTS).fill([]));
    setRowsAnswers(() => createDecodeRows());
    setDecodeRows(new Array(ATTEMPTS).fill(false));
    setWinnerModal(false);
    setOutOfChances(false);
    createCode();
    setGamePickUp(false);
    localStorage.removeItem('hints');
    localStorage.removeItem('activatedRow');
    localStorage.removeItem('decoded');
    localStorage.removeItem('decodes');
    localStorage.removeItem('codex');
  };
    
  // console.log(SUCCESSCODE)
  // correct guess in console
  //  Array.from(SUCCESSCODE).map(item => {
  //    const idx = CODES.indexOf(item[1]);
  //    console.log(idx + 1)
  //  })

  return (
    <ThemeContext.Provider value ={theme}>
      <div className={`mx-auto w-full min-h-screen text-center ${theme.backgroundColor} ${theme.foregroundColor} pt-2`}>
        {showNotification && <div className="xs:w-5/6 sm:w-1/3  mx-auto">
          <Notification message={"Start with a single type of peg in each row"} icon ={<PingIcon className = "mt-0.5"/>} position={{top:0}}/>
        </div>}
        <h1 className="pt-4 text-4xl font-title">MASTERMIND
          <span className="fixed top-34 right-4" onClick={() => setSettings(!openSettings)}>
            <SettingIcon height={"28px"} width = {"28px"}/>
          </span>
        </h1>
        { openSettings 
        && <Settings 
          setAttempts = {setAttempts}
          setPegsInRow = {setPegsInRow}
          setSettings = {setSettings}
          setTheme = {setTheme}
          setLevel = {setLevel}
          restartGame = {restartGame}
        />}
        {displayRules
        ?
        <div className="xs:w-5/6 sm:w-4/6 mx-auto">
          <Guide setDisplayRules={setDisplayRules} />
        </div>
        :  
        (<div
          onClick={() => setDisplayRules(!displayRules)}
          style={{ cursor: "pointer" }}
          className = "text-sky-500 font-bold"
        >
        <h4>How to play <span><FaAngleDoubleDown className="inline animate-bounce" /></span></h4>
        </div>)
        }
        
        <MastermindBoard
          CODES = {CODES} 
          ATTEMPTS = {ATTEMPTS} 
          PEGSINROW = {PEGSINROW}
          SUCCESSCODE = {SUCCESSCODE}
          activatedRow = {activatedRow}
          setActivatedRow = {setActivatedRow}
          decodeRowsHints = {decodeRowsHints}
          setDecodeRowsHints = {setDecodeRowsHints}
          rowsAnswers = {rowsAnswers}
          setRowsAnswers = {setRowsAnswers}
          restartGame = {restartGame}
          decodeRows = {decodeRows}
          setDecodeRows = {setDecodeRows}
          setOutOfChances = {setOutOfChances}
          setWinnerModal = {setWinnerModal}

        />
        <div>
          <p className="text-sm mt-4">
            ~developed by{" "}
            <a
              href="https://www.linkedin.com/in/sudhirraj31"
              target="_blank"
              rel="noreferrer"
              style={{ cursor: "pointer" }}
            >
              {" "}
              <span className="underline">Sudhir Raj</span>
            </a>
          </p>
        </div>

        {outOfChances && 
          <Modal
            title = {"Oops!"}
            description = {"You are out of chances! We know you are not a loser. Let's give it a one more try!"}
            actionName = {"Try Again"}
            action = {restartGame}
            isDismissRequired = {true}
            dismissName = {'Cancel'}
            dismiss = {() => setOutOfChances(false)}
            icon = {<SadFaceIcon size={"34px"} fillColor = {"#E96479"} strokeWidth={0.5} strokeColor ={"#fff"}/>}
            iconBg = {"bg-red-100"}
            showTemplate = {true}
            template = {<WinnerTemplate SUCCESSCODE = {SUCCESSCODE} theme = {theme} />}
          />}
          {winnerModal && 
          <Modal
            modalFor="winner"
            title = {"Bravo!"}
            description = {"You are a genius!"}
            actionName = {"Play again"}
            action = {restartGame}
            // isDismissRequired = {true}
            // dismissName = {'Cancel'}
            // dismiss = {() => setWinnerModal(false)}
            icon = {<HappyFaceIcon size={"34px"} fillColor = {"#E384FF"} strokeWidth={0.5} strokeColor ={"#fff"}/>}
            iconBg = {"bg-cyan-100"}
          />}

          {gamePickUp && 
          <Modal
            title = {"Continue Game?"}
            description = {"Don't worry. You can pick up your game where you left off."}
            actionName = {"Continue"}
            action = {() => setGamePickUp(false)}
            isDismissRequired = {true}
            dismissName = {'Restart'}
            dismiss= {restartGame}
            icon = {<ShieldExclamationIcon size={"34px"} fillColor = {"#E384FF"} strokeWidth={1.5} strokeColor ={"#fff"}/>}
            iconBg = {"bg-cyan-100"}
          />}
      </div>
    </ThemeContext.Provider>
  );
}

const WinnerTemplate = (props) => {
  return(
      <div className={`my-4 drop-shadow-lg ${props.theme.backgroundColor} rounded-xl py-2`}>
        <div className="flex justify-center">
          {Array.from(props.SUCCESSCODE).map(([key, value], i) => <Peg key={i} name={"Peg"} color = {value} />)}
        </div>
        <div className="font-semibold text-xs text-center">
          Correct Combination
        </div>
      </div>
  )
}

  